import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import PendingTimesheetList from '../../components/timesheets/pending-timesheet-list';

export default function PendingTimesheetsPage() {
  const { user, logout } = useAuth();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  const handleApprovalComplete = () => {
    // Trigger a refresh of the list
    setRefreshKey(prev => prev + 1);
  };

  if (!user) {
    return (
      <div className="pending-timesheets-page">
        <div className="loading-state">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pending-timesheets-page">
      <main className="page-main">
        <PendingTimesheetList key={refreshKey} onApprove={handleApprovalComplete} />
      </main>

      <style jsx>{`
        .pending-timesheets-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #f5f7fa 0%, #f9f9f9 100%);
        }

        .loading-state {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          font-size: 18px;
          color: #999;
        }

        .page-header {
          background: white;
          border-bottom: 1px solid #e0e0e0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .header-content {
          max-width: 1400px;
          margin: 0 auto;
          padding: 24px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .header-left {
          flex: 1;
        }

        .page-header h1 {
          margin: 0 0 6px 0;
          font-size: 32px;
          font-weight: 700;
          color: #333;
        }

        .header-subtitle {
          margin: 0;
          color: #999;
          font-size: 14px;
          font-weight: 500;
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .user-info {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          font-size: 14px;
        }

        .user-name {
          font-weight: 600;
          color: #333;
          margin-bottom: 2px;
        }

        .user-role {
          color: #999;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }

        .btn-logout {
          padding: 10px 20px;
          background: #f44336;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          transition: all 0.2s;
          white-space: nowrap;
        }

        .btn-logout:hover {
          background: #da190b;
          box-shadow: 0 2px 8px rgba(244, 67, 54, 0.3);
        }

        .btn-logout:active {
          transform: scale(0.98);
        }

        .page-main {
          max-width: 1400px;
          margin: 0 auto;
          padding: 24px 20px;
        }

        @media (max-width: 768px) {
          .header-content {
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
          }

          .header-right {
            width: 100%;
            justify-content: space-between;
          }

          .page-header h1 {
            font-size: 24px;
          }

          .header-subtitle {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
}
